import { render, staticRenderFns } from "./VueLoader.vue?vue&type=template&id=3473988f&scoped=true&"
import script from "./VueLoader.vue?vue&type=script&lang=js&"
export * from "./VueLoader.vue?vue&type=script&lang=js&"
import style0 from "./VueLoader.vue?vue&type=style&index=0&id=3473988f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3473988f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VProgressLinear})
